import React, { Suspense, lazy, useEffect, useState } from "react";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema } from "../seo/seoConfig";
import Spinner from "./ui/spinner";
import SessionsHero from "./pages/sessions/sessions-hero";
import SessionsUpcoming from "./pages/sessions/sessions-upcoming";
import SessionsPast from "./pages/sessions/sessions-past";
import SessionsYoutube from "./pages/sessions/sessions-youtube";
import SessionsForgeCta from "./pages/sessions/sessions-forge-cta";
import {
  loadSessionsFromSheet,
  attachYoutubeMedia,
  SESSIONS_FALLBACK,
} from "../utils/sessions-sheet";

const Footer = lazy(() => import("./footer"));

export const SessionsPage = () => {
  const seo = SEO_PAGES.sessions;
  const [upcoming, setUpcoming] = useState(null);
  const [past, setPast] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let cancelled = false;

    loadSessionsFromSheet()
      .then((data) => {
        if (cancelled) return;
        setUpcoming(data.upcoming);
        setPast(data.past);
      })
      .catch(async () => {
        if (cancelled) return;
        const past = await attachYoutubeMedia(SESSIONS_FALLBACK.past);
        if (cancelled) return;
        setUpcoming(SESSIONS_FALLBACK.upcoming);
        setPast(past);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Sessions", path: "/sessions" },
          ]),
        ]}
      />
      <div id="sessions-page">
        <main className="flex flex-col bg-white">
          <SessionsHero />
          <SessionsUpcoming upcoming={upcoming} loading={loading} />
          <SessionsPast sessions={past} loading={loading} />
          <SessionsYoutube />
          <SessionsForgeCta />
          <Suspense fallback={<Spinner />}>
            <Footer />
          </Suspense>
        </main>
      </div>
    </>
  );
};

export default SessionsPage;
